import { Grid, Typography, Box, TextField, InputAdornment, Button, IconButton, Checkbox, FormControlLabel, CircularProgress, } from "@mui/material";
import styleCss from "../Style/style";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from 'yup';
import { useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import showToast from "../Utilities/showToast";
import { AuthLogin } from "../ReduxStore/authSlice";
import { useDispatch } from "react-redux";
import { NonAuthAxios } from "../Utilities/CommonAxios";
import { encryptData } from "../Utilities/crypto";




export const MobileLogin = () => {

    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const handleToggle = () => setShowPassword(!showPassword);

    const mobileFormik = useFormik({

        enableReinitialize: true,
        initialValues: {
            mobile: "",
            password: ""
        },
        validationSchema: Yup.object({
            mobile: Yup.string()
                .matches(/^[0-9]{10,15}$/, "Mobile number must be valid (10 to 15 digits)")
                .min(10, "Mobile number must be at least 10 digits")
                .max(10, "Mobile number cannot be longer than 15 digits")
                .required("Enter valid mobile number"),
            password: Yup.string()
                .required("Enter the password")
        }),
        validateOnChange: true,
        validateOnBlur: true,
        onSubmit: async (values) => {
            setLoading(true);
            try {
                const { payload: response } = await dispatch(AuthLogin({
                    ...values,
                    login_type: "2"
                }));
                if (response.status) {
                    showToast('success', response.message);
                    navigate('/');
                } else {
                    showToast('error', response.message);
                }
            } catch (error) {
                console.error("Login error:", error);
                showToast('error', 'Something went wrong. Please try again.');
            } finally {
                setLoading(false);
            }
        }
    })

    const handleOtpClick = async (e) => {
        e.preventDefault();
        if (mobileFormik.errors.mobile) {
            mobileFormik.setFieldTouched('mobile', true, true)
            mobileFormik.setFieldError('Enter mobile number')
        }
        if (!mobileFormik.errors.mobile) {
            const apiResponse = await NonAuthAxios({
                url: '/otp',
                method: 'post',
                payload: {
                    mobile: mobileFormik.values.mobile
                }
            })

            if (apiResponse.status) {
                showToast('success', 'otp send to mobile number')
                navigate(`/verify-otp/${encryptData(mobileFormik.values.mobile)}/${encryptData(apiResponse?.data)}`);
            } else {
                showToast('error', apiResponse.message)
            }
        }
    }


    return (<Box>
        <form onSubmit={mobileFormik.handleSubmit}>
            <Grid container spacing={2}>

                <Grid size={{ md: 12, xs: 12 }}>
                    <Typography sx={styleCss.CommonLabelName}>Mobile Number:</Typography>
                    <TextField
                        name="mobile"
                        onChange={mobileFormik.handleChange}
                        value={mobileFormik.values.mobile}
                        error={mobileFormik.touched.mobile && Boolean(mobileFormik.errors.mobile)}
                        variant="outlined"
                        size="small"
                        placeholder="Enter mobile number"
                        fullWidth
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start" sx={{ fontSize: "13px", fontFamily: "Segoe UI", padding: '10px', }}>
                                    +91
                                </InputAdornment>
                            ),
                        }}
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                backgroundColor: "#f3f3f5",
                                borderRadius: "8px",
                                minHeight: "32px",
                                padding: 0,
                                "& input": {
                                    padding: "12px 10px",
                                    fontSize: "13px",
                                    "&::placeholder": {
                                        fontSize: "13px",
                                        color: "#717182",
                                        opacity: 1,
                                        fontFamily: "Segoe UI",
                                    },
                                },
                                "& fieldset": { borderColor: "#ddd" },
                                "&:hover fieldset": { borderColor: "#bbb" },
                                "&.Mui-focused fieldset": { borderColor: "transparent" },
                            },
                            "& .MuiInputLabel-root": {
                                fontFamily: "Segoe UI",
                                fontSize: "14px",
                                color: "#364252",
                            },
                        }}
                    />
                </Grid>
                <Grid size={{ md: 12, xs: 12 }}>
                    <Typography sx={styleCss.CommonLabelName}>Password:</Typography>
                    <TextField
                        name="password"
                        onChange={mobileFormik.handleChange}
                        value={mobileFormik.values.password}
                        error={mobileFormik.touched.password && Boolean(mobileFormik.errors.password)}
                        variant="outlined"
                        size="small"
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter your password"
                        fullWidth
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                backgroundColor: "#f3f3f5",
                                borderRadius: "8px",
                                minHeight: "32px",
                                padding: 0,
                                "& input": {
                                    padding: "12px 10px",
                                    fontSize: "13px",
                                    "&::placeholder": {
                                        fontSize: "13px",
                                        color: "#717182",
                                        opacity: 1,
                                        fontFamily: "Segoe UI",
                                    },
                                },
                                "& fieldset": { borderColor: "#ddd" },
                                "&:hover fieldset": { borderColor: "#bbb" },
                                "&.Mui-focused fieldset": { borderColor: "transparent" },
                            },
                            "& .MuiInputLabel-root": {
                                fontFamily: "Segoe UI",
                                fontSize: "14px",
                                color: "#364252",
                            },
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={handleToggle} edge="end" sx={{ marginRight: 'unset' }}>
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </Grid>
                <Grid size={{ md: 6, xs: 6 }}>
                    <FormControlLabel
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            fontFamily: "Segoe UI",
                        }}
                        control={
                            <Checkbox
                                sx={{
                                    color: "#1d3557",
                                    "&.Mui-checked": { color: "#1d3557" },
                                    padding: "0px 0px 0px 10px",
                                }}
                            />
                        }
                        label={
                            <Typography
                                component="span"
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "3px",
                                    fontFamily: "Segoe UI",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    color: "#030213",
                                    whiteSpace: "nowrap",
                                    cursor: "pointer",
                                }}
                            >
                                Remember me
                            </Typography>
                        }
                    />
                </Grid>
                <Grid size={{ md: 6, xs: 6 }} sx={{ textAlign: "right" }}>
                    <Link

                        to='/'
                        style={{
                            fontSize: "15px",
                            fontWeight: "normal",
                            color: "#ff5714",
                            fontFamily: "Segoe UI",
                            textDecoration: "none",
                            display: "inline-block",
                            textAlign: "right",
                        }}
                    >
                        Forgot Password?
                    </Link>
                </Grid>
                <Grid size={{ md: 12, xs: 12 }}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                            gap: 1.5,
                        }}
                    >
                        <Link
                            onClick={handleOtpClick}
                            style={{
                                fontSize: "15px",
                                fontWeight: "normal",
                                color: "#ff5714",
                                fontFamily: "Segoe UI",
                                textDecoration: "none",
                                display: "inline-block",
                                textAlign: "right",
                            }}
                        >
                            Login via otp
                        </Link>
                    </Box>
                </Grid>
                <Grid size={{ md: 12, xs: 12 }}>
                    <Button type="submit" variant="contained" sx={{
                        borderRadius: "8px",
                        boxShadow: "0 4px 100px 0 rgba(0, 0, 0, 0.08)",
                        backgroundColor: "#ff5714",
                        fontFamily: "Segoe UI",
                        fontSize: "15px",
                        fontWeight: "500",
                        fontStretch: "normal",
                        fontStyle: "normal",
                        lineHeight: "normal",
                        letterSpacing: "normal",
                        textAlign: "left",
                        color: "#fff",
                        textTransform: "none",
                        width: '100%',
                        padding: '10px 16px',
                        "&:hover": {
                            backgroundColor: "#e64e12",
                            boxShadow: "0 6px 120px 0 rgba(0, 0, 0, 0.12)",
                        },
                    }} > {loading ? (
                        <CircularProgress size={20} color="inherit" />
                    ) : (
                        "Login"
                    )}</Button>
                </Grid>

            </Grid>
        </form>
    </Box>)
}